import SequenceNav from './SequenceNav';
import { Outlet } from 'react-router-dom';

function SequenceLayout() {
    return (
        <div>
            <SequenceNav />
            <Outlet />
        </div>
    );
}

export default SequenceLayout;
